import { container } from "tsyringe";

// impl
import StoreManagerImpl from "@/shared/libs/state-management";
import type { ClientStateManager } from "@/shared/libs/stores/client/interface";

import useChallengesClientStore from "@/shared/libs/stores/client/challenge-up";
import useChallengeSearchStudentStore from "@/shared/libs/stores/client/challenge-search-student";

// type
import type { ChallengesClientState } from "@/shared/model/store/challeng-up/interface";
import type { ChallengeSearchStudentState } from "@/shared/model/store/challenge-search-student/interface";

const stateRegisterInit = () => {
    container.register<ClientStateManager.ChallengesClient>("ChallengeUpManager", {
        useValue: new StoreManagerImpl<ChallengesClientState>(useChallengesClientStore()),
    });
    container.register<ClientStateManager.ChallengeSearchStudent>("ChallengeSearchStudentManager", {
        useValue: new StoreManagerImpl<ChallengeSearchStudentState>(
            useChallengeSearchStudentStore(),
        ),
    });
};

export default stateRegisterInit;
